export const STALE_CHUNK_RELOAD_KEY = 'chunk-reload-attempted';
export const STALE_CHUNK_RELOAD_COOLDOWN_MS = 5 * 60_000;

const STALE_CHUNK_MESSAGE_PATTERN = /Failed to fetch dynamically imported module|Importing a module script failed/;

export function isStaleChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : typeof error === 'string' ? error : '';

  return STALE_CHUNK_MESSAGE_PATTERN.test(message);
}

export function reloadOnceOnStaleChunk(error: unknown, reloadPage: () => void, now: number = Date.now()): boolean {
  if (!isStaleChunkError(error)) {
    return false;
  }

  try {
    const lastReloadAt = Number(sessionStorage.getItem(STALE_CHUNK_RELOAD_KEY));
    if (lastReloadAt && now - lastReloadAt < STALE_CHUNK_RELOAD_COOLDOWN_MS) {
      return false;
    }
    sessionStorage.setItem(STALE_CHUNK_RELOAD_KEY, String(now));
  } catch {
    return false;
  }

  reloadPage();
  return true;
}

export function dropStaleChunkEvent<T>(event: T, originalException: unknown, reloadPage: () => void): T | null {
  return reloadOnceOnStaleChunk(originalException, reloadPage) ? null : event;
}
